const media = {
    //IMGS
    iddriver_logo: require("./imgs/iddriver_logo.svg").default,

    banner1: require("./imgs/banner1.jpg"),
    banner2: require("./imgs/banner2.jpg"),
    banner3: require("./imgs/banner3.jpg"),
    banner4: require("./imgs/banner4.jpg"),

    benefits_icon1: require("./imgs/benefits_icon1.svg").default,
    benefits_icon2: require("./imgs/benefits_icon2.svg").default,
    benefits_icon3: require("./imgs/benefits_icon3.svg").default,
    benefits_icon4: require("./imgs/benefits_icon4.svg").default,

    why_icon1: require("./imgs/why_icon1.svg").default,
    why_icon2: require("./imgs/why_icon2.svg").default,
    why_icon3: require("./imgs/why_icon3.svg").default,
    why_icon4: require("./imgs/why_icon4.svg").default,

    //FILES
    process_flow: require("./files/process_flow.pdf"),
    dealer_survey: require("./files/dealer_survey.pdf"),
}

export default media;